<template>
  <v-app class="margin-tool-bary">
    <v-app-bar color="primary" dense dark fixed max-height="46">
      <v-app-bar-nav-icon icon @click.stop="drawer = !drawer" />
      <v-toolbar-title>
        {{ setTitleNavBar() }}
      </v-toolbar-title>
      <v-spacer />
      <!-- lazy-src="https://webadmin.capital28.investments/static/img/capital28-logo-blanco.png" -->

      <div class="center-me">
        <v-img
          v-if="realEstateGroupLogo"
          max-height="36"
          max-width="200"
          contain
          :src="realEstateGroupLogo"
        ></v-img>
      </div>
      <v-spacer />
      <component v-if="toolbarLayout" v-bind:is="toolbarLayout"></component>
      <!-- icono menú lateral derecho de filtros -->
      <v-app-bar-nav-icon v-if="filterLayout" @click.stop="openLeadsFilter()">
        <div>
          <v-btn icon>
            <v-tooltip bottom>
              <template v-slot:activator="{ on }">
                <div v-if="someFilterSelected">
                  <v-icon color="amber" class="filter-glow" v-on="on"
                    >mdi-tune</v-icon
                  >
                </div>
                <div v-else>
                  <v-icon v-on="on">mdi-tune</v-icon>
                </div>
              </template>
              <span>Filtros</span>
            </v-tooltip>
          </v-btn>
        </div>
      </v-app-bar-nav-icon>
    </v-app-bar>

    <v-navigation-drawer
      temporary
      v-model="drawer"
      app
      color="blue-grey darken-2"
      dark
      width="240"
      :src="`${publicPath}sidebar-bg.png`"
    >
      <template v-slot:prepend>
        <v-list-item class="d-flex align-center px-2">
          <v-menu
            offset-y
            v-model="menuSettings"
            :close-on-click="false"
            :close-on-content-click="false"
          >
            <template v-slot:activator="{ on }">
              <v-hover>
                <v-chip
                  slot-scope="{ hover }"
                  :class="`elevation-${hover ? 5 : 0}`"
                  v-ripple
                  color="transparent"
                  text-color="white"
                  label
                  v-on="on"
                >
                  <v-avatar>
                    <img width="32px" height="32px" :src="userImageSrc" />
                  </v-avatar>
                  <v-icon>
                    mdi-chevron-down
                  </v-icon>
                </v-chip>
              </v-hover>
            </template>
            <v-card
              min-width="340"
              max-width="340"
              rounded="lg"
              flat
              color="transparent"
            >
              <!-- User info -->
              <v-list class="pa-0">
                <v-list-item class="py-2">
                  <v-list-item-avatar size="40">
                    <img :src="userImageSrc" alt="avatar" />
                  </v-list-item-avatar>
                  <v-list-item-content>
                    <v-list-item-title class="text-body-2 font-weight-medium">
                      {{ userData && userData.name ? userData.name : "—" }}
                    </v-list-item-title>
                    <v-list-item-subtitle class="text-caption">
                      {{ userData && userData.email ? userData.email : "—" }}
                    </v-list-item-subtitle>
                  </v-list-item-content>
                  <div
                    v-if="userRole !== 'developer'"
                    class="d-flex align-center"
                    style="gap:6px"
                  >
                    <v-tooltip bottom color="primary">
                      <template v-slot:activator="{ on, attrs }">
                        <v-chip
                          x-small
                          outlined
                          :loading="isLoadingUserData"
                          v-bind="attrs"
                          v-on="on"
                        >
                          {{ getLeadsPerformance(userData).total }}
                        </v-chip>
                      </template>
                      <div>
                        Total: {{ getLeadsPerformance(userData).total }} —
                        Activos: {{ getLeadsPerformance(userData).active }}
                      </div>
                    </v-tooltip>
                    <v-tooltip bottom color="warning">
                      <template v-slot:activator="{ on, attrs }">
                        <v-chip
                          x-small
                          outlined
                          color="warning"
                          :loading="isLoadingUserData"
                          v-bind="attrs"
                          v-on="on"
                        >
                          {{ getLeadsPerformance(userData).defeated }}
                        </v-chip>
                      </template>
                      <span>Leads que requieren atención</span>
                    </v-tooltip>
                  </div>
                </v-list-item>
              </v-list>

              <v-divider />

              <!-- Menu options -->
              <v-list dense class="py-1">
                <v-list-item
                  v-for="(item, index) in optionsSettings"
                  :key="index"
                  link
                  @click="item.toMethod(userData)"
                >
                  <v-list-item-icon class="mr-3 my-auto">
                    <v-icon small>{{ item.prefixIcon }}</v-icon>
                  </v-list-item-icon>
                  <v-list-item-content>
                    <v-list-item-title class="text-body-2">
                      {{ item.title }}
                    </v-list-item-title>
                  </v-list-item-content>
                  <v-list-item-icon v-if="item.appendIcon" class="my-auto">
                    <v-icon small color="grey lighten-1">
                      {{ item.appendIcon }}
                    </v-icon>
                  </v-list-item-icon>
                </v-list-item>

                <!-- Cambiar de cuenta -->
                <v-menu
                  :close-on-content-click="false"
                  :nudge-width="220"
                  offset-x
                  content-class="py-0"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <v-list-item link v-bind="attrs" v-on="on">
                      <v-list-item-icon class="mr-3 my-auto">
                        <v-icon small>mdi-office-building</v-icon>
                      </v-list-item-icon>
                      <v-list-item-content>
                        <v-list-item-title class="text-body-2">
                          Cambiar de cuenta
                        </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </template>

                  <v-card v-if="currentSession" elevation="1" rounded="lg">
                    <v-list dense class="pa-0">
                      <v-list-item>
                        <v-list-item-avatar size="32">
                          <img :src="userImageSrc" alt="avatar" />
                        </v-list-item-avatar>
                        <v-list-item-content>
                          <v-list-item-title
                            class="text-body-2 font-weight-medium"
                            v-text="currentSession.name"
                          />
                          <v-list-item-subtitle
                            class="text-caption"
                            v-text="currentSession.email"
                          />
                          <v-list-item-subtitle
                            class="text-caption"
                            v-text="currentSession.nameRealestate"
                          />
                        </v-list-item-content>
                      </v-list-item>
                    </v-list>
                    <v-divider />
                    <v-list dense class="py-1">
                      <v-list-item
                        v-for="(session, index) in sessions.filter(
                          _session => _session._id !== currentSession._id
                        )"
                        :key="index"
                        link
                        @click="changeSession(session)"
                      >
                        <v-list-item-avatar size="32">
                          <v-img
                            :src="
                              session.img
                                ? session.img
                                : 'https://dummyimage.com/44x44/ffffff/2e394a&text=28'
                            "
                          />
                        </v-list-item-avatar>
                        <v-list-item-content>
                          <v-list-item-title
                            class="text-body-2"
                            v-text="session.name"
                          />
                          <v-list-item-subtitle class="text-caption">
                            {{ session.email }}
                          </v-list-item-subtitle>
                          <v-list-item-subtitle
                            class="text-caption"
                            v-text="session.nameRealestate"
                          />
                        </v-list-item-content>
                      </v-list-item>
                    </v-list>
                  </v-card>
                </v-menu>
              </v-list>

              <v-divider />

              <v-card-actions class="px-3 py-2">
                <v-btn
                  text
                  small
                  color="error"
                  class="text-capitalize"
                  @click="logOut"
                >
                  Cerrar Sesión
                </v-btn>
                <v-spacer />
                <v-btn icon small @click="getContactsList()">
                  <v-icon small>mdi-sync</v-icon>
                </v-btn>
                <v-btn icon small @click="menuSettings = false">
                  <v-icon small>mdi-close</v-icon>
                </v-btn>
              </v-card-actions>
            </v-card>
          </v-menu>
          <v-icon color="red lighten-2" class="ml-1" @click="logOut">
            mdi-power
          </v-icon>
        </v-list-item>
      </template>
      <component v-bind:is="navLayout"></component>
    </v-navigation-drawer>

    <v-main class="pa-0">
      <v-container class="pa-0" fluid>
        <slot />
      </v-container>
    </v-main>

    <v-navigation-drawer
      v-model="right"
      fixed
      right
      temporary
      color="blue-grey lighten-5"
    >
      <component v-if="filterLayout" v-bind:is="filterLayout"></component>
    </v-navigation-drawer>

    <lead-advanced-create-form
      v-if="
        userRole !== 'coordinator' &&
          userRole !== 'developer' &&
          userRole !== 'marketing' &&
          userRole !== 'marketingv2' &&
          showBtnCreateLead
      "
      ref="leadCreateComponent"
      @close-menu="onCloseDialogCreateLead"
    />
    <details-user-modal
      :visible="showUpdateUserModal"
      :user-to-update="userToUpdate"
      @close="onCloseUserToUpdatetModal"
    />
    <vue-snotify></vue-snotify>
    <modal-information :dialog="dialog" :messageServer="serverMessage" />
  </v-app>
</template>

<script>
import { mapState, mapActions, mapMutations } from "vuex";
import { LogOut, VerifyToken, changeSession } from "@/api/user-api.js";
import ModalInformation from "../layouts/nav/ModalInformation.vue";
import { getDataToken } from "../../helpers/auth-header";

export default {
  props: {
    source: String
  },
  components: {
    //Tiene el anterior registro
    LeadAdvancedCreateForm: () =>
      import("@/components/lead/LeadAdvancedCreateForm.vue"),
    AdminNav: () => import("@/components/layouts/nav/AdminNav"),
    DeveloperNav: () => import("@/components/layouts/nav/DeveloperNav"),
    BrokerNav: () => import("@/components/layouts/nav/BrokerNav"),
    RootNav: () => import("@/components/layouts/nav/RootNav"),
    MarketingNav: () => import("@/components/layouts/nav/MarketingNav"),
    MarketingV2Nav: () => import("@/components/layouts/nav/MarketingV2Nav"),
    CoordinatorNav: () => import("@/components/layouts/nav/CoordinatorNav"),

    LeadsFilter: () => import("@/components/layouts/filters/LeadsFilter"),
    PropertiesFilter: () =>
      import("@/components/layouts/filters/PropertiesFilter"),
    LeadsToolbar: () => import("@/components/layouts/toolbar/LeadsToolbar"),
    DetailsUserModal: () => import("@/components/user/UserUpdate.vue"),
    ModalInformation
  },
  filters: {
    shortName(n) {
      return n.substring(0, 12);
    }
  },
  data: () => ({
    drawer: false,
    leadsStatsLoading: true,
    menuSettings: false,
    right: false,
    isLoadingUserData: true,
    publicPath: process.env.BASE_URL,
    navLayout: "",
    filterLayout: "",
    toolbarLayout: "",
    collapseOnScroll: true,
    contactsList: null,
    userData: null,
    userRole: localStorage.getItem("user_role") || "",
    userImage: localStorage.getItem("user_image") || "",
    showUpdateUserModal: false,
    userToUpdate: null,
    showBtnCreateLead: false,
    dialog: false,
    serverMessage: "",
    realestateSelected: "Propiedades cancún"
  }),
  watch: {
    $route(newValue) {
      // actualizar la barra de filtros al cambiar la ruta
      this.filterLayout = this.setFilterLayout();
      this.toolbarLayout = this.setToolbarLayout();
      this.mostrarBtnCreateLead(newValue);
    },
    right(newValue) {
      if (!newValue) {
        this.closeLeadsFilter();
      }
    }
  },
  computed: {
    ...mapState({
      preferencesSt: state => state.preferences,
      filtersSt: state => state.leads.filter.filters,
      contactsListLoadingSt: state => state.contacts.ContactsListLoading,
      contactListSt: state => state.contacts.contactList,
      leadsTableFooterSt: state => state.leads.leadsTableFooter,
      filtersSelectedSt: state => state.leads.filter.filtersSelected,
      filtersSelectedChangedSt: state =>
        state.leads.filter.filtersSelectedChanged,
      someFilterSelected: state => state.leads.filter.filterSomeFilterSelected
    }),
    userName() {
      return this.$store.getters.userName;
    },
    optionsSettings: function() {
      return [
        {
          title: "Mi cuenta",
          prefixIcon: "mdi-account",
          appendIcon: "mdi-cog-outline",
          switch: false,
          toMethod: item => this.showDetails(item)
        }
      ];
    },
    realEstateGroupLogo() {
      try {
        if (this.$store.getters.realEstateGroupLogo) {
          return this.$store.getters.realEstateGroupLogo;
        } else {
          return require("@/assets/logo-capital28-blanco.png");
        }
      } catch (error) {
        return require("@/assets/logo-capital28-blanco.png");
      }
    },
    userImageSrc() {
      let contactImage = this.userImage;
      if (contactImage) return contactImage;
      contactImage = "https://dummyimage.com/44x44/ffffff/2e394a&text=28";
      return contactImage;
    },
    isLeadKanbanView() {
      return this.$route.path == "/admin/lead/kanban";
    },
    isLeadTableView() {
      return (
        this.$route.path == "/admin/lead" ||
        this.$route.path == "/admin/lead/" ||
        this.$route.path == "/admin/lead/list" ||
        this.$route.path == "/developer/lead" ||
        this.$route.path == "/developer/lead/" ||
        this.$route.path == "/developer/lead/list" ||
        this.$route.path == "/broker/lead" ||
        this.$route.path == "/broker/lead/" ||
        this.$route.path == "/broker/lead/list"
      );
    },
    sessions() {
      return JSON.parse(localStorage.getItem("sessions") || "[]");
    },
    currentSession() {
      const contact_id = localStorage.getItem("contact_id");
      return this.sessions.find(
        _session => _session?.contact_id === contact_id
      );
    }
  },
  async mounted() {
    await VerifyToken();
    this.getContactsList();
    this.mostrarBtnCreateLead(this.$route);
    this.fetchRealEstateGroupStore();
  },
  methods: {
    ...mapMutations({
      setLeadsTableFooterSt: "leads/setLeadsTableFooter",
      setFiltersSelectedSt: "leads/setFiltersSelected",
      setFiltersSelectedChangedSt: "leads/filter/setFiltersSelectedChanged",
      setLeadsPaginationClearSt: "leads/setLeadsPaginationClear",
      setClearFiltersSt: "leads/filter/setClearFilters",
      setFilteredLeadsSearched: "leads/setFilteredLeadsSearched",
      setSelectedItems: "leads/setSelectedItems"
    }),
    ...mapActions({
      fetchContactStore: "contacts/fetchContactList",
      getUserByIdStore: "getUserInfobyId",
      fetchLeadsleadsPaginationSt: "leads/fetchLeadsPagination",
      fetchGetLeadsKanbanByPhaseSt: "leads/fetchGetLeadsKanbanByPhase",
      fetchRealEstateGroupStore: "realEstateGroup/fecthRealEstateGroupDetail"
    }),
    mostrarBtnCreateLead(route) {
      if (route && route.path) {
        const path = route.path;
        let routesAcepted = ["leads", "external-broker"];
        this.showBtnCreateLead = routesAcepted.some(keyword =>
          path.includes(keyword)
        );
      } else {
        this.showBtnCreateLead = false;
      }
    },
    openLeadsFilter() {
      this.setFiltersSelectedChangedSt(false);
      this.right = !this.right;
    },
    closeLeadsFilter() {
      if (this.preferencesSt && this.preferencesSt.showKanbanFirst) {
        this.setClearFiltersSt(false);
        this.filterLeadsKanban();
      } else {
        this.setClearFiltersSt(false);
        this.filterLeadsTable();
      }
    },
    filterLeadsTable() {
      if (this.filtersSelectedChangedSt) {
        this.setFilteredLeadsSearched(false);
        this.setSelectedItems([]);
        this.setLeadsTableFooterSt(null);
        // Este codigo al poner el limite en 25
        // genera el error de las keys duplicadas
        this.fetchLeadsleadsPaginationSt({
          filter: this.filtersSelectedSt,
          page: 0,
          limit: 10,
          footer: this.leadsTableFooterSt
        });
      }
    },
    filterLeadsKanban() {
      if (this.filtersSelectedChangedSt) {
        this.setSelectedItems([]);
        this.setFilteredLeadsSearched(false);
        this.fetchGetLeadsKanbanByPhaseSt({
          filter: this.filtersSelectedSt,
          page: 0,
          phases: this.filtersSt.phases
        });
      }
    },
    onCloseDialogCreateLead() {
      this.$refs.leadCreateComponent.closeEverthing();
    },
    getContactsList() {
      const self = this;
      self.isLoadingUserData = true;
      const payload = getDataToken();
      let role = this.userRole;
      if (role === "") {
        self.userData = {};
        setTimeout(() => {
          self.navLayout = self.setNavLayout();
          self.filterLayout = self.setFilterLayout();
          self.toolbarLayout = self.setToolbarLayout();
        }, 500);
      } else if (
        role === "developer" ||
        role === "marketing" ||
        role === "marketingv2" ||
        role === "coordinator"
      ) {
        this.getUserByIdStore().then(res => {
          if (res.Message) {
            this.dialog = true;
            this.serverMessage = res.Message;
          }
          self.userData = res.User;
          setTimeout(() => {
            self.navLayout = self.setNavLayout();
            self.filterLayout = self.setFilterLayout();
            self.toolbarLayout = self.setToolbarLayout();
          }, 500);
          self.isLoadingUserData = false;
        });
      } else {
        this.getUserByIdStore().then(res => {
          if (res.Message) {
            this.dialog = true;
            this.serverMessage = res.Message;
          }
          localStorage.setItem("contactId", res.contact._id);

          let moduleQuoteTemp = "off";
          if (res.User) {
            if (res.User.real_estate_group[0]) {
              if (res.User.real_estate_group[0].moduleQuote) {
                moduleQuoteTemp = res.User.real_estate_group[0].moduleQuote;
              }
            }
          }
          localStorage.setItem("moduleQuote", moduleQuoteTemp);
        });
        this.fetchContactStore().then(res => {
          self.contactsList = res;
          self.userData = self.contactsList.filter(l => {
            return l._id === payload.contact_id;
          })[0];
          self.userData.user_id = payload.sub;
          setTimeout(() => {
            self.navLayout = self.setNavLayout();
            self.filterLayout = self.setFilterLayout();
            self.toolbarLayout = self.setToolbarLayout();
          }, 500);
          self.isLoadingUserData = false;
        });
      }
    },
    showDetails(item) {
      this.userToUpdate = item;
      this.$store.state.userData = item;
      this.showUpdateUserModal = true;
    },
    onCloseUserToUpdatetModal(data, dateEdited) {
      this.userToUpdate = null;
      this.showUpdateUserModal = false;
      if (dateEdited === "password") {
        this.logOut();
      } else {
        if (data !== null) {
          this.userData.name = data.name;
          this.userData.email = data.email;
        }
      }
    },
    getLeadsPerformance(data) {
      if (data && data.performance !== undefined) {
        return {
          total: data.performance.total,
          active: data.performance.active,
          defeated: data.performance.defeated
        };
      } else {
        return {
          total: 0,
          active: 0,
          defeated: 0
        };
      }
    },
    // pasar a una librería
    getSafeNestedField(fn, defaultVal) {
      try {
        return fn();
      } catch (e) {
        return defaultVal;
      }
    },
    logOut() {
      LogOut().then(() => {
        location.reload();
      });
    },
    // define el layout nav dependiendo del rol de usuario
    setNavLayout() {
      if (this.userRole === "admin") return "AdminNav";
      if (this.userRole === "developer") return "DeveloperNav";
      if (this.userRole === "broker") return "BrokerNav";
      if (this.userRole === "root") return "RootNav";
      if (this.userRole === "marketing") return "MarketingNav";
      if (this.userRole === "marketingv2") return "MarketingV2Nav";
      if (this.userRole === "coordinator") return "CoordinatorNav";
      return "BrokerNav";
    },
    setTitleNavBar() {
      try {
        const titlePage = document.title;
        const charDivisor = titlePage.indexOf("|");
        // contemplar espacio | y espacio en blanco
        return titlePage.substr(charDivisor + 2, titlePage.length);
      } catch (error) {
        return "";
      }
    },
    setFilterLayout() {
      let path = this.$route.path;
      if (path.includes("lead")) {
        return "LeadsFilter";
      }
      if (path.includes("property")) {
        return "";
      }
      return "";
    },
    setToolbarLayout() {
      let routeName = this.$route.name;
      if (
        [
          "AdminLeadsView",
          "BrokerLeadsView",
          "DeveloperLeadsView",
          "MarketingLeadsView",
          "MarketingV2LeadsView"
        ].includes(routeName)
      ) {
        return "LeadsToolbar";
      }
      return "";
    },
    getLeadsPostponend(stats) {
      if (stats.leadPostponed) {
        return stats.leadPostponed[0].count;
      } else {
        return 0;
      }
    },
    changeSession(session) {
      const newToken = session.token;
      changeSession(newToken, session.role).then(() => {
        window.location.reload();
      });
    }
  }
};
</script>
<style>
.v-application {
  background: #ffffff !important;
}
.margin-tool-bary {
  margin-top: 50px;
}
</style>

<style scoped>
.center-me {
  position: absolute;
  margin-left: 50%;
  transform: translate(-50%, 0);
}
.filter-glows {
  padding: 13px;
  border-radius: 50%;
  background-color: rgba(255, 236, 131, 0);
  box-shadow: 0 0 10px 5px rgb(255, 236, 131),
    /* inner white */ 0 0 25px 10px rgba(255, 251, 0, 0.597),
    /* middle magenta */ 0 0 35px 20px rgb(252, 255, 76); /* outer cyan */
}
</style>
